<div class="overlay-txt-content">
    <span class="overlay-app-name"> {{ betbuilderMessages?.OverlayTriggerTitle }} </span>
    <span class="overlay-app-desc"> {{ betbuilderMessages?.OverlayTriggerSubtitle }} </span>
</div>
<button class="betbuilder-overlay-trigger--button btn btn-secondary btn-sm" (click)="openBuilder()">
    {{ betbuilderMessages?.OverlayTriggerButton }}
</button>

<ng-template #header>
    <ms-betbuilder-overlay-header
        [eventName]="event.name"
        [sportId]="event.sport.id"
        [leagueId]="event.league.id"
        [eventId]="event.id"
        [eventStartDate]="event.startDate"
        [eventParticipants]="event.participants"
        [eventViewType]="event.viewType" />
</ng-template>
